import React from 'react';

/**
 * Component that parses text with parentheses markers and renders them as bold.
 * Example: "I love to (run)" renders as "I love to run" with "run" in bold.
 *
 * @param {string} text - The text with parentheses markers
 * @returns {JSX.Element} Rendered text with bold formatting
 */
export const HighlightedText = ({ text }) => {
  if (!text) return null;

  // Regular expression to match text inside parentheses
  const regex = /\(([^)]+)\)/g;
  const parts = [];
  let lastIndex = 0;
  let match;

  // Find all occurrences of (word)
  while ((match = regex.exec(text)) !== null) {
    // Add text before the match
    if (match.index > lastIndex) {
      parts.push({
        text: text.substring(lastIndex, match.index),
        bold: false,
      });
    }

    // Add the matched word (without parentheses, as bold)
    parts.push({
      text: match[1], // The captured group (word without parentheses)
      bold: true,
    });

    lastIndex = regex.lastIndex;
  }

  // Add remaining text after last match
  if (lastIndex < text.length) {
    parts.push({
      text: text.substring(lastIndex),
      bold: false,
    });
  }

  // If no matches found, return original text
  if (parts.length === 0) {
    return <span>{text}</span>;
  }

  // Render parts with bold formatting
  return (
    <span>
      {parts.map((part, index) => (
        part.bold ? (
          <strong key={index} className="font-bold text-gray-900">
            {part.text}
          </strong>
        ) : (
          <span key={index}>{part.text}</span>
        )
      ))}
    </span>
  );
};
